/* global __THREEKIT_AUTH_TOKEN__,  __THREEKIT_HOST__ */
import { THREEKIT_AUTH_TOKEN, THREEKIT_HOST } from '../../threekitEnv';

const b64toBlob = (dataURI, mimeType) => {
  const byteString = atob(dataURI.split(',')[1]);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);

  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], { type: mimeType });
};

const postThumbnail = async (dataUrl, mimeType) => {
  const url = `${THREEKIT_HOST}/api/files?bearer_token=${THREEKIT_AUTH_TOKEN}`;
  const blob = b64toBlob(dataUrl, mimeType);
  // const blob = await fetch(dataUrl).then((res) => res.blob());
  const postfix = mimeType.split('/')[1];
  const formData = new FormData();
  const filename = `lovesac-${new Date().toISOString()}.${postfix}`;
  formData.append('files', new File([blob], filename));
  formData.append('filename', filename);

  const domain = THREEKIT_HOST.replace('https://', '');

  return fetch(url, {
    method: 'post',
    body: formData,
    accept: 'application/json',
    'content-type': 'multipart/form-data',
  })
    .then((res) => res.json())
    .then((json) => {
      const { id } = json.files[0];
      return `${THREEKIT_HOST}/api/images/webp/filters:format(webp):quality(80)/${domain}/api/files/${id}/content`;
      // return `${THREEKIT_HOST}/api/files/${id}/content`;
    });
};

export async function getThumbnail(width, height, mimeType = 'image/png') {
  const size = width && height ? { width, height } : undefined;
  const blob = await window.threekit.api.snapshotAsync({
    size,
    mimeType,
  });

  return postThumbnail(blob, mimeType);
}
